export default {
  viewBox: "0 0 25 24",
  html: "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M4.5 5c-.5 0-1 .4-1 1v12c0 .5.5 1 1 1H21c.6 0 1-.5 1-1V6c0-.6-.4-1-1-1zm1 2v10H20V7z\" clip-rule=\"evenodd\"/>"
};